import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { HochrechnungPeriod, HochrechnungSourceEntity } from './types';
import { Hochrechnung } from './Hochrechnung';

export const HochrechnungPrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const sourceEntityS = urlSearchParams.get('sourceEntity');
    const sourceEntity: HochrechnungSourceEntity = sourceEntityS === 'rechnung' ? 'rechnung' : 'auftrag';

    const periodS = urlSearchParams.get('period');
    const period: HochrechnungPeriod = periodS === 'calendaryear' ? 'calendaryear' : 'accountingyear';

    return <Hochrechnung sourceEntity={sourceEntity} period={period} printView />;
};
